import styled from 'styled-components'

export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .infos {
    display: flex;
    flex-direction: column;

    span {
      font-size: 12px;
      color: #7b7b7b;
      font-weight: 500;
    }

    p {
      margin: 0;
      padding: 0;
      font-weight: 700;
    }
  }
`
